import PostItems from 'components/containers/PostItems/PostItems';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { CompanyLogos, HeroImageTop, Statistics } from 'components/containers';
import { CustomArticleSlugTypes } from 'types/global';
import { PageWrapper } from 'components/presentional';
import { usePages, usePosts } from 'hooks';
import { useRouteTranslations } from 'utils/languages';
import { WPAcfBlog, WPAcfCaseStudies } from 'types/acf';
import { WPSimplePage } from 'types/pages';
import { WPSimpleArticle } from 'types/articles';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';

interface OwnProps {}

type CaseStudiesPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const CaseStudiesPage: FunctionComponent<CaseStudiesPageProps> = props => {
  const POSTS_PER_PAGE = 9;
  const CASE_STUDIES_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'case_studies';
  const { translateSlug } = useRouteTranslations();
  const { formatMessage } = useIntl();
  const [perPage, setPerPage] = useState(POSTS_PER_PAGE);
  const [caseStudiesItems, setCaseStudiesItems] = useState<WPSimpleArticle<WPAcfBlog>[]>([]);

  const { data: page, loading } = usePages<WPSimplePage<WPAcfCaseStudies>>({ slug: translateSlug(CASE_STUDIES_PAGE_SLUG_TYPE) });

  const { data: caseStudies, loading: caseStudiesLoading } = usePosts<WPSimpleArticle<WPAcfBlog>>({
    category_name: 'case_study',
    per_page: perPage + 1,
  });

  useEffect(() => {
    if (caseStudies && !caseStudiesLoading) {
      setCaseStudiesItems([...caseStudies.slice(0, perPage)]);
    }
  }, [caseStudies, perPage, caseStudiesLoading]);

  const [customPage] = page || [];

  if (!customPage) {
    return null;
  }

  const {
    acf: { heroImageTop, statistics, companyLogos },
  } = customPage;

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={CASE_STUDIES_PAGE_SLUG_TYPE}>
      <HeroImageTop data={heroImageTop} />
      <Statistics data={statistics} />
      <div>
        {caseStudies && !caseStudiesLoading && (
          <PostItems
            mobile={1}
            tablet={3}
            desktop={3}
            category={translateSlug(CASE_STUDIES_PAGE_SLUG_TYPE)}
            posts={caseStudiesItems}
            header={formatMessage(messages.our_missions)}
            linkLabel={formatMessage(messages.learn_more)}
            length={perPage}
            loadMore={caseStudies.length > perPage}
            onLoadMore={() => setPerPage(perPage + POSTS_PER_PAGE)}
          />
        )}
      </div>
      <CompanyLogos data={companyLogos} />
    </PageWrapper>
  );
};

export default CaseStudiesPage;
